/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_REBATE_PERCENT,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ADJUSTMENT_REBATE_PERCENT,
  isLoading: value,
});
export const setReduxDataSearchScreen = (value) => ({
  type: ActionTypes.SET_SELECT_ROWS,
  searchScreen: value,
});
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

// export const dispatchRebatePrograme = (data) => ({
//   type: ActionTypes.GET_REBATE_PROGRAM_REBATE_PERCENT,
//   payload: data,
// });

// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_REBATE_PERCENT,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// API call for the DRAMS starting quarter
export const getDRAMSQuarter = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_DRAMS_QUARTER,
        dramsQtr: response.data?.dramsInvoiceStartQuarter,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

export const getFirstSummaryQtr = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_FIRST_SUMMARY_REPORT_OPTION}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.FIRST_SUMMARY_VALUE,
        payload: response.data?.firstSummaryReportQuarter,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch({ type: ActionTypes.FIRST_SUMMARY_VALUE, payload: '' });
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setRebatePercentData = (data) => ({
  type: ActionTypes.GET_SEARCH_RESULT_REBATE_PERCENT,
  searchResult: data,
});

// API call for the display screen grid
export const getSearchResult = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.REBATE_PERCENT_OF_SPEND}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.rebatePercentOfSpendGetAllMfgVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setRebatePercentData(response.data?.rebatePercentOfSpendGetAllMfgVO)
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRebatePercentData([]));
      // return response;
    });
};

// set Initial value of store
export const refreshRebatePercent = () => ({
  type: ActionTypes.REFRESH_REBATE_PERCENT,
  payload: {},
});
export const refreshRebatePercentDisplay = () => ({
  type: ActionTypes.SET_REFRESH_REBATE_PERCENT_DISPLAY,
  payload: {},
});
export const setRebatePercentExportAll = (data, mfgIds) => ({
  type: ActionTypes.SET_EXPORT_ALL_REBATE_PERCENT,
  payload: { data, mfgIds },
});

export const reportData = (values, name) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.REBATE_PERCENT_OF_SPEND, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setRebatePercentExportAll(
          response?.data?.rebatePercentOfSpendGetAllMfgVO,
          name
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRebatePercentExportAll([], name));
    });
};

export const getRebatePercentExportAll =
  ({ rebateProgramCode, isAllMfg, fromQtr, toQtr, mfgIds, manufacturerList }) =>
  (dispatch) => {
    const tempObj = {};
    const mfgList = manufacturerList?.rebatePercentOfSpendMfgGridVO || [];
    for (let i = 0; i < mfgList.length; i++) {
      tempObj[mfgList[i].mfgId] = `${mfgList[i].mfgId} - ${mfgList[i].mfgName}`;
    }
    for (let i = 0; i < mfgIds?.length; i++) {
      const values = {
        rebateProgramCode,
        isAllMfg,
        fromQtr,
        toQtr,
        mfgIds: [mfgIds[i]],
      };

      dispatch(reportData(values, tempObj[mfgIds[i]]));
    }
  };
